const TYPEOFENTITY = [
  {
    name: "Sole Proprietorship",
    code: "sole_proprietorship",
  },
  {
    name: "Partnership",
    code: "partnership",
  },
  {
    name: "C Corporation",
    code: "c_corporation",
  },
  {
    name: "S Corporation",
    code: "s_corporation",
  },
  {
    name: "Limited Liability Company (LLC)",
    code: "limited_liability_company",
  },
];

const businessType = [
  {
    label: "Sole Proprietorship",
    value: "sole_proprietorship",
  },
  {
    label: "Partnership",
    value: "partnership",
  },
  {
    label: "C Corporation",
    value: "c_corporation",
  },
  {
    label: "S Corporation",
    value: "s_corporation",
  },
  {
    label: "Limited Liability Company (LLC)",
    value: "limited_liability_company",
  },
];

const taxClassificationTypes = businessType.slice(1, 4);

export { TYPEOFENTITY as default, businessType, taxClassificationTypes };
